module.exports = __webpack_public_path__ + "static/media/card-content-quiz.99101e76.svg";